export const teachersConstants = {
    SHOW_TEACHER_COURSES: 'SHOW_TEACHER_COURSES',
    SHOW_COURSE_SUBJECT: 'SHOW_COURSE_SUBJECT',
    SHOW_COURSE_STUDENTS: 'SHOW_COURSE_STUDENTS',
    SHOW_COURSE_EVALS: 'SHOW_COURSE_EVALS',
    SHOW_COURSE_STUDENT_EVALS: 'SHOW_COURSE_STUDENT_EVALS',

    ADD_COURSE_STUDENT_EVALS: 'ADD_COURSE_STUDENT_EVALS',
    UPD_COURSE_STUDENT_EVALS: 'UPD_COURSE_STUDENT_EVALS',
    DEL_COURSE_STUDENT_EVALS: 'DEL_COURSE_STUDENT_EVALS',

    SHOW_ALL_EVALS: 'SHOW_ALL_EVALS',

    SHOW_COURSE_NOTEBOOK_TOOLS: 'SHOW_COURSE_NOTEBOOK_TOOLS',
    SHOW_COURSE_NOTEBOOK_ITEMS: 'SHOW_COURSE_NOTEBOOK_ITEMS',
    ADD_COURSE_NOTEBOOK_ITEM: 'ADD_COURSE_NOTEBOOK_ITEM'
 
};